import { render, staticRenderFns } from "./layout-bottom.vue?vue&type=template&id=b32c20ca&scoped=true&"
import script from "./layout-bottom.vue?vue&type=script&lang=js&"
export * from "./layout-bottom.vue?vue&type=script&lang=js&"
import style0 from "./layout-bottom.vue?vue&type=style&index=0&id=b32c20ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32c20ca",
  null
  
)

export default component.exports